import { Revision } from './types';

export function getRevisionId(revision: Revision) {
  return `${revision.revision}-${revision.editorType}`;
}

export function isSeparateRevisionsCheck(revisions: Revision[]) {
  // source of truth is in /site-revisions-server/templates/site-revisions-server.json.erb
  const dateOfNewAdiRevisions = '2017-04-23T18:00:00.000Z';
  const lastRevision = revisions[revisions.length - 1];
  return (
    new Date(lastRevision.dateCreated).getTime() >=
    new Date(dateOfNewAdiRevisions).getTime()
  );
}

export function getRevisionLink(
  siteId: string,
  storyId: string,
  metaSiteId: string,
  revision: Revision,
) {
  if (revision.editorType === 'adi') {
    return `https://www.wix.com/website/builder?previewMode=true&storyId=${storyId}#!/builder/story/${storyId}:${metaSiteId}/preview?previewRevision=${revision.revision}`;
  }
  if (window.location.href.includes('manage.editorx.com')) {
    return `https://create.editorx.com/html/editor/web/renderer/revisions/view/${siteId}/${revision.revision}?metaSiteId=${metaSiteId}&referer=revisions`;
  }
  return `https://editor.wix.com/html/editor/web/renderer/revisions/view/${siteId}/${revision.revision}?metaSiteId=${metaSiteId}&referer=revisions`;
}

export function getEditorLink(
  siteId: string,
  storyId: string,
  metaSiteId: string,
) {
  return `https://editor.wix.com/html/editor/web/renderer/edit/${siteId}?metaSiteId=${metaSiteId}#!/builder/story/${storyId}:${metaSiteId}`;
}

export function getAdiLink(
  siteId: string,
  storyId: string,
  metaSiteId: string,
) {
  return `http://www.wix.com/website/builder?storyId=${storyId}#!/builder/story/${storyId}:${metaSiteId}`;
}
